// import React, { useEffect, useState } from "react";
// import axios from "../../axiosInstance";
// import { message, Modal } from "antd";
// import Button from "@mui/material/Button";
// import jsPDF from "jspdf";
// import { Box } from "@mui/material";
// import DownloadIcon from "@mui/icons-material/Download";

// const QuestionPaperPDF = ({ id }) => {
//   const [questions, setQuestions] = useState([]);
//   const [examName, setExamName] = useState("");

//   // Fetch exam data by ID
//   const fetchExamById = async () => {
//     try {
//       const response = await axios.get(`/api/v1/exam/${id}`);
//       setQuestions(response.data.data.questions);
//       setExamName(response.data.data.name);
//     } catch (error) {
//       message.error(
//         error?.response?.data?.message || "Failed to fetch question paper"
//       );
//     }
//   };

//   // Utility function to strip HTML tags
//   const stripHtmlTags = (html) => {
//     if (!html) return "";
//     const div = document.createElement("div");
//     div.innerHTML = html;
//     return div.textContent || div.innerText || "";
//   };

//   // Get option text from option object
//   const getOptionText = (option) => {
//     if (typeof option === 'string') return stripHtmlTags(option);
//     if (option && option.text) return stripHtmlTags(option.text);
//     return "";
//   };

//   // Get correct options indices and texts
//   const getCorrectOptionsInfo = (question) => {
//     if (!question.correctOptions || !Array.isArray(question.correctOptions)) {
//       return [];
//     }
    
//     return question.correctOptions.map(correctOpt => {
//       // If correctOpt is an object with optionIndex
//       if (typeof correctOpt === 'object' && correctOpt.optionIndex !== undefined) {
//         const idx = correctOpt.optionIndex;
//         const option = question.options[idx];
//         return {
//           index: idx,
//           text: getOptionText(option),
//           letter: String.fromCharCode(97 + idx) // a, b, c, d
//         };
//       }
//       // If correctOpt is just a number (legacy)
//       else if (typeof correctOpt === 'number') {
//         const option = question.options[correctOpt];
//         return {
//           index: correctOpt,
//           text: getOptionText(option),
//           letter: String.fromCharCode(97 + correctOpt)
//         };
//       }
//       return null;
//     }).filter(item => item !== null);
//   };

//   // Function to generate Question Paper PDF
//   const generateQuestionPaperPDF = () => {
//     Modal.confirm({
//       title: "Download Question Paper",
//       content: "Would you like to download the question paper PDF file?",
//       okText: "Yes, Download",
//       cancelText: "No, Cancel",
//       onOk: () => {
//         try {
//           const doc = new jsPDF({
//             orientation: "p",
//             unit: "mm",
//             format: "a4",
//           });

//           let yPos = 10;

//           // Add exam title centered
//           doc.setFontSize(16);
//           doc.text(examName, doc.internal.pageSize.width / 2, yPos, {
//             align: "center",
//           });
//           yPos += 15;

//           questions.forEach((question, index) => {
//             // Question text
//             const questionText = `${index + 1}. ${stripHtmlTags(question.questionText)}`;
            
//             // Add question image if exists
//             let questionImageHeight = 0;
//             if (question.questionImage && question.questionImage !== "") {
//               try {
//                 doc.addImage(question.questionImage, 'JPEG', 10, yPos, 50, 50);
//                 questionImageHeight = 55;
//               } catch (error) {
//                 console.error("Error adding question image:", error);
//               }
//             }
            
//             yPos += questionImageHeight;

//             // Options
//             const optionsText = question.options.map((option, idx) => {
//               const optionText = getOptionText(option);
//               return `${String.fromCharCode(97 + idx)}. ${optionText}`;
//             }).join("\n");

//             const content = doc.splitTextToSize(
//               `${questionText}\n\n${optionsText}`,
//               doc.internal.pageSize.width - 20
//             );

//             // Check if content fits on the page
//             if (
//               yPos + doc.getTextDimensions(content).h >
//               doc.internal.pageSize.height - 10
//             ) {
//               doc.addPage();
//               yPos = 10;
//             }

//             doc.setFontSize(12);
//             doc.text(content, 10, yPos);
//             yPos += doc.getTextDimensions(content).h + 10;
//           });

//           doc.save(`${examName}_question_paper.pdf`);
//           message.success("Question Paper PDF downloaded successfully!");
//         } catch (error) {
//           console.error("PDF Error:", error);
//           message.error("Error generating the Question Paper PDF.");
//         }
//       },
//     });
//   };

//   // Function to generate Answer Key PDF
//   const generateAnswerKeyPDF = () => {
//     Modal.confirm({
//       title: "Download Answer Key",
//       content: "Would you like to download the answer key PDF file?",
//       okText: "Yes, Download",
//       cancelText: "No, Cancel",
//       onOk: () => {
//         try {
//           const doc = new jsPDF({
//             orientation: "p",
//             unit: "mm",
//             format: "a4",
//           });

//           let yPos = 10;
          
//           // Add title
//           doc.setFontSize(16);
//           doc.text(
//             `Answer Key - ${examName}`,
//             doc.internal.pageSize.width / 2,
//             yPos,
//             { align: "center" }
//           );
//           yPos += 15;

//           questions.forEach((question, index) => {
//             const questionText = `${index + 1}. ${stripHtmlTags(question.questionText)}`;
            
//             // Get options list
//             const optionsList = question?.options?.map((option, idx) => {
//               const optionText = getOptionText(option);
//               return `${String.fromCharCode(97 + idx)}. ${optionText}`;
//             });

//             // Get correct answers info
//             const correctAnswersInfo = getCorrectOptionsInfo(question);
            
//             const correctAnswersText = correctAnswersInfo.length > 0 
//               ? correctAnswersInfo.map(info => `${info.letter}. ${info.text}`).join(", ")
//               : "No correct answer specified";

//             const answerKeyText = `${questionText}\n\nOptions:\n${optionsList.join("\n")}\n\n✓ Correct Answer(s): ${correctAnswersText}`;
            
//             const content = doc.splitTextToSize(
//               answerKeyText,
//               doc.internal.pageSize.width - 20
//             );

//             // Check if content fits on the page
//             if (
//               yPos + doc.getTextDimensions(content).h >
//               doc.internal.pageSize.height - 10
//             ) {
//               doc.addPage();
//               yPos = 10;
//             }

//             doc.setFontSize(12);
//             doc.text(content, 10, yPos);
            
//             // Add separator line between questions
//             yPos += doc.getTextDimensions(content).h + 8;
            
//             if (index !== questions.length - 1) {
//               doc.setDrawColor(200, 200, 200);
//               doc.line(10, yPos - 4, doc.internal.pageSize.width - 10, yPos - 4);
//             }
//           });

//           doc.save(`${examName}_answer_key.pdf`);
//           message.success("Answer Key PDF downloaded successfully!");
//         } catch (error) {
//           console.error("PDF Error:", error);
//           message.error("Error generating the Answer Key PDF.");
//         }
//       },
//     });
//   };

//   useEffect(() => {
//     if (id) {
//       fetchExamById();
//     }
//   }, [id]);

//   return (
//     <Box className="question-paper">
//       <Button
//         variant="contained"
//         color="primary"
//         onClick={generateQuestionPaperPDF}
//         startIcon={<DownloadIcon />}
//         className="courses_desc"
//         sx={{
//           mb: 2,
//           justifyContent: "space-between",
//           borderRadius: "5px",
//           textTransform: "none",
//           fontFamily: "Poppins, sans-serif",
//           letterSpacing: ".1rem",
//         }}
//       >
//         Question Paper
//       </Button>

//       <Button
//         variant="contained"
//         color="primary"
//         onClick={generateAnswerKeyPDF}
//         startIcon={<DownloadIcon />}
//         style={{ marginLeft: "10px" }}
//         className="courses_desc"
//         sx={{
//           mb: 2,
//           justifyContent: "space-between",
//           borderRadius: "5px",
//           textTransform: "none",
//           fontFamily: "Poppins, sans-serif",
//           letterSpacing: ".1rem",
//         }}
//       >
//         Answer Key
//       </Button>
//     </Box>
//   );
// };

// export default QuestionPaperPDF;

import React, { useEffect, useState } from "react";
import axios from "../../axiosInstance";
import { message, Modal } from "antd";
import Button from "@mui/material/Button";
import jsPDF from "jspdf";
import { Box } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";

const QuestionPaperPDF = ({ id }) => {
  const [questions, setQuestions] = useState([]);
  const [examName, setExamName] = useState("");

  // Fetch exam data by ID
  const fetchExamById = async () => {
    try {
      const response = await axios.get(`/api/v1/exam/${id}`);
      setQuestions(response.data.data.questions);
      setExamName(response.data.data.name);
    } catch (error) {
      message.error(
        error?.response?.data?.message || "Failed to fetch question paper"
      );
    }
  };

  // Utility function to strip HTML tags and clean text
  const cleanText = (html) => {
    if (!html) return "";
    // Remove HTML tags
    const div = document.createElement("div");
    div.innerHTML = html;
    let text = div.textContent || div.innerText || "";
    // Remove special characters and extra spaces
    text = text.replace(/[^\w\s\u0900-\u097F.,?!]/g, ''); // Keep Hindi characters
    text = text.replace(/\s+/g, ' ').trim();
    return text;
  };

  // Get option text from option object
  const getOptionText = (option) => {
    if (typeof option === 'string') return cleanText(option);
    if (option && option.text) return cleanText(option.text);
    return "";
  };

  // Get unique options (remove duplicates)
  const getUniqueOptions = (options) => {
    const seen = new Set();
    const unique = [];
    for (const option of options) {
      const optionText = getOptionText(option);
      if (!seen.has(optionText)) {
        seen.add(optionText);
        unique.push(option);
      }
    }
    return unique;
  };

  // Get correct options info with proper indexing after removing duplicates
  const getCorrectOptionsInfo = (question) => {
    if (!question.correctOptions || !Array.isArray(question.correctOptions)) {
      return [];
    }
    
    // Get unique options first
    const uniqueOptions = getUniqueOptions(question.options);
    
    // Create a mapping from original index to new index
    const originalToNewIndex = {};
    let newIndex = 0;
    const seenTexts = new Set();
    
    question.options.forEach((option, originalIdx) => {
      const optionText = getOptionText(option);
      if (!seenTexts.has(optionText)) {
        seenTexts.add(optionText);
        originalToNewIndex[originalIdx] = newIndex;
        newIndex++;
      }
    });
    
    return question.correctOptions.map(correctOpt => {
      let originalIndex;
      if (typeof correctOpt === 'object' && correctOpt.optionIndex !== undefined) {
        originalIndex = correctOpt.optionIndex;
      } else if (typeof correctOpt === 'number') {
        originalIndex = correctOpt;
      } else {
        return null;
      }
      
      const newIdx = originalToNewIndex[originalIndex];
      if (newIdx !== undefined) {
        const uniqueOptionsList = getUniqueOptions(question.options);
        return {
          index: newIdx,
          text: getOptionText(uniqueOptionsList[newIdx]),
          letter: String.fromCharCode(97 + newIdx) // a, b, c, d
        };
      }
      return null;
    }).filter(item => item !== null);
  };

  // Function to generate Question Paper PDF
  const generateQuestionPaperPDF = () => {
    Modal.confirm({
      title: "Download Question Paper",
      content: "Would you like to download the question paper PDF file?",
      okText: "Yes, Download",
      cancelText: "No, Cancel",
      onOk: () => {
        try {
          const doc = new jsPDF({
            orientation: "p",
            unit: "mm",
            format: "a4",
          });

          let yPos = 10;

          // Add exam title centered
          doc.setFontSize(16);
          doc.text(examName, doc.internal.pageSize.width / 2, yPos, {
            align: "center",
          });
          yPos += 15;

          questions.forEach((question, index) => {
            // Question text
            const questionText = `${index + 1}. ${cleanText(question.questionText)}`;
            
            // Get unique options for display
            const uniqueOptions = getUniqueOptions(question.options);
            
            // Options
            const optionsText = uniqueOptions.map((option, idx) => {
              const optionText = getOptionText(option);
              return `${String.fromCharCode(97 + idx)}. ${optionText}`;
            }).join("\n");

            const content = doc.splitTextToSize(
              `${questionText}\n\n${optionsText}`,
              doc.internal.pageSize.width - 20
            );

            // Check if content fits on the page
            if (
              yPos + doc.getTextDimensions(content).h >
              doc.internal.pageSize.height - 10
            ) {
              doc.addPage();
              yPos = 10;
            }

            doc.setFontSize(12);
            doc.text(content, 10, yPos);
            yPos += doc.getTextDimensions(content).h + 10;
          });

          doc.save(`${examName.replace(/[^a-z0-9]/gi, '_')}_question_paper.pdf`);
          message.success("Question Paper PDF downloaded successfully!");
        } catch (error) {
          console.error("PDF Error:", error);
          message.error("Error generating the Question Paper PDF.");
        }
      },
    });
  };

  // Function to generate Answer Key PDF
  const generateAnswerKeyPDF = () => {
    Modal.confirm({
      title: "Download Answer Key",
      content: "Would you like to download the answer key PDF file?",
      okText: "Yes, Download",
      cancelText: "No, Cancel",
      onOk: () => {
        try {
          const doc = new jsPDF({
            orientation: "p",
            unit: "mm",
            format: "a4",
          });

          let yPos = 10;
          
          // Add title
          doc.setFontSize(16);
          doc.text(
            `Answer Key - ${examName}`,
            doc.internal.pageSize.width / 2,
            yPos,
            { align: "center" }
          );
          yPos += 15;

          questions.forEach((question, index) => {
            const questionText = `${index + 1}. ${cleanText(question.questionText)}`;
            
            // Get unique options
            const uniqueOptions = getUniqueOptions(question.options);
            
            // Get options list
            const optionsList = uniqueOptions.map((option, idx) => {
              const optionText = getOptionText(option);
              return `${String.fromCharCode(97 + idx)}. ${optionText}`;
            });

            // Get correct answers info (after removing duplicates)
            const correctAnswersInfo = getCorrectOptionsInfo(question);
            
            // Remove duplicate correct answers
            const uniqueCorrectAnswers = [];
            const seenTexts = new Set();
            for (const answer of correctAnswersInfo) {
              if (!seenTexts.has(answer.text)) {
                seenTexts.add(answer.text);
                uniqueCorrectAnswers.push(answer);
              }
            }
            
            const correctAnswersText = uniqueCorrectAnswers.length > 0 
              ? uniqueCorrectAnswers.map(info => `${info.letter}. ${info.text}`).join(", ")
              : "No correct answer specified";

            // Use proper bullet point (•) instead of special character
            const answerKeyText = `${questionText}\n\nOptions:\n${optionsList.join("\n")}\n\n• Correct Answer(s): ${correctAnswersText}`;
            
            const content = doc.splitTextToSize(
              answerKeyText,
              doc.internal.pageSize.width - 20
            );

            // Check if content fits on the page
            if (
              yPos + doc.getTextDimensions(content).h >
              doc.internal.pageSize.height - 10
            ) {
              doc.addPage();
              yPos = 10;
            }

            doc.setFontSize(12);
            doc.text(content, 10, yPos);
            
            // Add separator line between questions
            yPos += doc.getTextDimensions(content).h + 8;
            
            if (index !== questions.length - 1) {
              doc.setDrawColor(200, 200, 200);
              doc.line(10, yPos - 4, doc.internal.pageSize.width - 10, yPos - 4);
            }
          });

          doc.save(`${examName.replace(/[^a-z0-9]/gi, '_')}_answer_key.pdf`);
          message.success("Answer Key PDF downloaded successfully!");
        } catch (error) {
          console.error("PDF Error:", error);
          message.error("Error generating the Answer Key PDF.");
        }
      },
    });
  };

  useEffect(() => {
    if (id) {
      fetchExamById();
    }
  }, [id]);

  return (
    <Box className="question-paper">
      <Button
        variant="contained"
        color="primary"
        onClick={generateQuestionPaperPDF}
        startIcon={<DownloadIcon />}
        className="courses_desc"
        sx={{
          mb: 2,
          justifyContent: "space-between",
          borderRadius: "5px",
          textTransform: "none",
          fontFamily: "Poppins, sans-serif",
          letterSpacing: ".1rem",
        }}
      >
        Question Paper
      </Button>

      <Button
        variant="contained"
        color="primary"
        onClick={generateAnswerKeyPDF}
        startIcon={<DownloadIcon />}
        style={{ marginLeft: "10px" }}
        className="courses_desc"
        sx={{
          mb: 2,
          justifyContent: "space-between",
          borderRadius: "5px",
          textTransform: "none",
          fontFamily: "Poppins, sans-serif",
          letterSpacing: ".1rem",
        }}
      >
        Answer Key
      </Button>
    </Box>
  );
};

export default QuestionPaperPDF;